import adjustViewport from "@module/adjustViewport";
import toggleGnav from "@module/toggleGnav";
import initAOS from "@module/initAOS";
import fadeSlider from "@module/fadeSlider";
import topProjectSlider from "@module/topProjectSlider";
import pickupSlider from "@module/pickupSlider";
import topAboutSlider from "@module/topAboutSlider";
import parallax from "@module/parallax";
import popup from "@module/popup";
import accordion from "@module/accordion";
import showGotop from "@module/showGotop";
import smoothScroll from "@module/smoothScroll";
import updateRightItems from "@module/updateRightItems";
import searchDetailSlider from "@module/searchDetailSlider";
import accordionReadMore from "@module/accordionReadMore";
import tab from "@module/tab";
// import fixFooterToBottom from "@module/fixFooterToBottom";

// import blockContinuitySubmit from "@module/blockContinuitySubmit"; //フォーム連続送信防止
// import FormDeleteInvalid from "@module/FormDeleteInvalid"; //フォームエラー表示

import '@scss/style.scss';

adjustViewport();
toggleGnav(true);
initAOS();
fadeSlider();
parallax();
popup();
accordion();
showGotop();
smoothScroll();
pickupSlider();
// fixFooterToBottom();

// トップページ
if (document.body.id === 'top') {
    // headerChangeBg();
    topProjectSlider();
    topAboutSlider();
    tab();

    
// 検索結果
} else if (document.body.id === 'search') {
    updateRightItems();
    searchDetailSlider();
    accordionReadMore();
}


